import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ModalActions, modalSelect, selectActiveModal } from 'primsell-shared-layer/features'
import { IModalConfig, IModalState, ModalVariantT } from 'primsell-shared-layer/types'

interface IUseModal<T> {
  activeModal: ModalVariantT
  openModal: (payload: IModalConfig<T>) => void
  closeModal: () => void
  modalConfig: IModalConfig<T>
}

export function useModal<T>(): IUseModal<T> {
  const dispatch = useDispatch()

  const activeModal = useSelector(selectActiveModal)

  const { modalConfig }: IModalState<T> = useSelector(modalSelect)

  const openModal = useCallback(
    (payload: IModalConfig<T>) => {
      dispatch(ModalActions.openModal(payload))
    },
    [dispatch]
  )

  const closeModal = useCallback(() => {
    dispatch(ModalActions.closeModal())
  }, [dispatch])

  return {
    activeModal,
    modalConfig,
    openModal,
    closeModal,
  }
}
